




import { Component, Vue } from "vue-property-decorator"
import Tariffs from "../Tarification/Tariffs.vue";
import { TarificationTypes, TarificationTransports } from "@/store/tarification/types";

@Component({ components: {Tariffs} })
export default class ViberProviderTariffs extends Vue {
  private partnerType: TarificationTypes = TarificationTypes.OPERATOR;
  private tarificationTransport: TarificationTransports = TarificationTransports.WHATSAPP;
}
